// extracted by mini-css-extract-plugin
export default {"quiz_header":"xo","quiz_header_wrapper":"yo","header_button":"zo","hidden":"Ao","gainful_logo":"Bo","MyClassEnterDone":"Co","x_button":"Eo","logoWrapper":"Fo","logoWrapperMob":"Go"};
    if(module.hot) {
      // 1714654883412
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  